import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import LoadingAdapter from "libs/utils/LoadingAdapter";
import SurrogateService from "services/SurrogateService";


let initialState = { list: [] };

export const getSurrogates = createAsyncThunk(
  "surrogate/getSurrogates",
  async () => {
    const response = await SurrogateService.getSurrogate();
    return response?.results;
  }
);

export const addSurrogates = createAsyncThunk(
  "surrogate/addSurrogates",
  async (body) => {
    const _body = {
      list: [...body]
    };
    const response = await SurrogateService.addSurrogate(_body);
    return response?.results;
  }
);



const surrogateSlice = createSlice({
  name: "surrogate",
  initialState: LoadingAdapter.getInitialState(initialState),
  reducers: {
    clearAll: LoadingAdapter.getInitialState(initialState),
    clearAsyncState: LoadingAdapter.clearAsyncState,
  },
  extraReducers: (builder) => {
    LoadingAdapter.applyAsyncBuilder(getSurrogates, builder, ["list"]);
    LoadingAdapter.applyAsyncBuilder(addSurrogates, builder);
  },
});

export default surrogateSlice.reducer;

